export interface GenerateMemoryDto {
  smartAssistantId: string;
  conversationContext: string;
  memoryPrompt: string;
  memoryCondition?: string;
}

export interface GenerateMemoryResponseDto {
  memory: string;
  userFacingReasoning: string;
}

export enum MemoryType {
  GENERIC = 'GENERIC'
}

export interface GenericMemoryContent {
  content: string;
}

export interface Memory {
  type: MemoryType;
  genericMemoryContent: GenericMemoryContent;
}
